import { useState } from "react";
import { PageTitle } from "@/components/ui/PageTitle";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { TutorialDialog } from "@/components/tutorials/TutorialDialog";
import { TutorialList } from "@/components/tutorials/TutorialList";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const Tutorials = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingTutorial, setEditingTutorial] = useState<any>(null);

  const handleEdit = (tutorial: any) => {
    setEditingTutorial(tutorial);
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setEditingTutorial(null);
  };

  const handleSuccess = () => {
    handleClose();
  };

  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <PageTitle 
          title="Gestion des tutoriels" 
          subtitle="Gérez les tutoriels pour vos utilisateurs"
        />
        <Button onClick={() => setIsDialogOpen(true)}>
          <Plus className="w-4 h-4 mr-2" />
          Nouveau tutoriel
        </Button>
      </div>

      <TutorialList onEdit={handleEdit} />

      <TutorialDialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        onSuccess={handleSuccess}
        editingTutorial={editingTutorial}
      />
    </div>
  );
};

export default Tutorials;